import {UserRole} from "../GraphQL/generated/graphql";
import {hasAdministratorRole, hasOrganizerWorkspaceAccess} from "./OrganizerRoles";
import {
    BuildingRegular,
    Building20Regular,
    CalendarLtr20Regular,
    CalendarLtrRegular,
    DocumentPercent20Regular,
    DocumentPercentRegular,
    PeopleMoney20Regular,
    PeopleMoneyRegular,
    TaskListRtl20Regular,
    TaskListRtlRegular
} from "@fluentui/react-icons";
import React from "react";

export enum MenuItemType {
    Administration
}

export type MenuItem = {
    type?: MenuItemType;
    translationKey: string;
    icon?: JSX.Element;
    smallIcon?: JSX.Element;
    children?: MenuItem[];
    route: string;
    descriptionKey?: string;
};

export const MenuDefinition = (roles: UserRole[]): MenuItem[] => {
    const items: MenuItem[] = [];

    if (hasOrganizerWorkspaceAccess(roles)) {
        items.push({
            translationKey: "events",
            descriptionKey: "events-description",
            route: "/Admin/Events",
            icon: <CalendarLtrRegular/>,
            smallIcon: <CalendarLtr20Regular/>,
            type: MenuItemType.Administration
        }, {
            translationKey: "archive",
            descriptionKey: "archive-description",
            route: "/Admin/Events/Archive",
            icon: <TaskListRtlRegular/>,
            smallIcon: <TaskListRtl20Regular/>,
            type: MenuItemType.Administration
        }, {
            translationKey: "payers",
            descriptionKey: "payers-description",
            route: "/Admin/Payers",
            icon: <PeopleMoneyRegular/>,
            smallIcon: <PeopleMoney20Regular/>,
            type: MenuItemType.Administration
        }, {
            translationKey: "hotels",
            descriptionKey: "hotels-description",
            route: "/Admin/Hotels",
            icon: <BuildingRegular/>,
            smallIcon: <Building20Regular/>,
            type: MenuItemType.Administration
        });
    }

    // Organization settings are administrator-only; other organizers would land on a 403 page.
    if (hasAdministratorRole(roles)) {
        items.push({
            translationKey: "global-settings",
            descriptionKey: "general-settings-description",
            route: "/Admin/GeneralSettings",
            icon: <DocumentPercentRegular/>,
            smallIcon: <DocumentPercent20Regular/>,
            type: MenuItemType.Administration
        });
    }

    return items;
}
